import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';

export const contextSchema = new schema.Entity(EntityTypes.Context);
